import React from "react";
import { Link } from "react-router-dom";
import Container from "../../components/Container";
import CustomInput from "../../components/CustomInput";
import logo from "../../assets/images/logo.png";
import { IoArrowForwardOutline } from "react-icons/io5";
import Button from "../../components/Button";

const ConfirmEmail = () => {
  return (
    <section>
      <Container maxWidth={"max-w-3xl"}>
        <div className="header my-6">
          <div className="flex justify-between items-center">
            <div className="logo w-28">
              <Link to={"/everyone"}>
                <img src={logo} alt="" />
              </Link>
            </div>
            <div className="sign-in">
              <Link to={"/everyone"} className="flex items-center gap-3 p-3">
                <span>Sign In</span>
                <span>
                  <IoArrowForwardOutline />
                </span>
              </Link>
            </div>
          </div>
        </div>
        <div className="bg-white xs:p-4 md:p-10 border rounded-lg">
          <div className="text-lg font-semibold mb-6">
            <p className="">
              Confirm Your Email, we will send you a code to this email
            </p>
          </div>
          <div className="form my-3">
            <form action="flex flex-auto">
              <div className="email flex-auto mb-4 flex flex-col">
                <CustomInput
                  label={"Your Email"}
                  placeholder="Type your email"
                  name="email"
                  type="email"
                  className="w-full mb-4"
                />
              </div>
              <div className="continue flex-auto mb-4 flex flex-col">
                <Link to="/reset-password/code">
                  <Button width={"w-full"}>Send Code</Button>
                </Link>
              </div>
            </form>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default ConfirmEmail;
